import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

/**
 * This pipe transforms date from string to Moment.
 */
@Pipe({
  name: 'dateParse',
})
export class DateParsePipe implements PipeTransform {

  /**
   * Transforms date from string to Moment.
   * @param value date value in string.
   */
  transform(value: string) {
    if (!value) {
      return;
    }

    return moment(value, 'YYYY-MM-DD k:mm:ss');
  }
}
